/**
 * Text styles from the Phone UI file (Host Grotesk, 0% letter spacing).
 * Weights match the Figma suffixes: 400 Regular, 500 Medium, 600 SemiBold.
 * The older textStyles map stays in typography.js for screens already using it.
 */

import { defineTextStyle } from './typography';

export const PHONE_TYPE_SCALE = [
  { group: 'micro', token: 'micro', size: 8, lineHeight: 12 },
  { group: 'label-x-small', token: 'label-xs', size: 9, lineHeight: 12 },
  { group: 'label-small', token: 'label-s', size: 10, lineHeight: 14 },
  { group: 'label', token: 'label', size: 12, lineHeight: 16 },
  { group: 'body', token: 'body', size: 14, lineHeight: 18 },
  { group: 'large', token: 'large', size: 16, lineHeight: 20 },
  { group: 'title', token: 'title', size: 18, lineHeight: 22 },
  { group: 'headline-small', token: 'headline-s', size: 20, lineHeight: 24 },
  { group: 'headline-medium', token: 'headline-m', size: 24, lineHeight: 28 },
  { group: 'headline-large', token: 'headline-l', size: 28, lineHeight: 32 },
];

export const PHONE_TYPE_WEIGHTS = [
  { suffix: '400', weight: 400 },
  { suffix: '500', weight: 500 },
  { suffix: '600', weight: 600 },
];

export const phoneTypeSpecs = PHONE_TYPE_SCALE.flatMap((step) =>
  PHONE_TYPE_WEIGHTS.map((item) => ({
    key: `${step.group}/${step.token}-${item.suffix}`,
    size: step.size,
    lineHeight: step.lineHeight,
    weight: item.weight,
  }))
);

export const phoneTextStyles = phoneTypeSpecs.reduce((styles, spec) => {
  styles[spec.key] = defineTextStyle({
    fontSize: spec.size,
    lineHeight: spec.lineHeight,
    letterSpacing: 0,
    fontWeight: spec.weight,
  });
  return styles;
}, {});

export function getPhoneTextStyle(name) {
  const style = phoneTextStyles[name];
  if (!style) {
    throw new Error(`Unknown phone text style: ${name}`);
  }
  return style;
}
